/* eslint-disable padding-line-between-statements */
import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { QuestionSetComponent } from '@xengage/gw-portals-questionsets-ui';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useModal} from '@jutro/components';
import { ViewModelForm, ViewModelServiceContext, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import _, { clone } from 'lodash';
import React, { useCallback, useContext, useEffect, useState, useMemo } from 'react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import TFPAConstructionDetails from '../../components/ConstructionDetails/TFPAConstructionDetails/TFPAConstructionDetails';
import TFPARoofUpdatesComponent from 'ent-capability-quoteandbind-common-react/components/ConstructionDetails/ENTRoofUpdatesComponent/ENTRoofUpdatesComponent';
import TFPAAdditionalDetails from '../../components/ConstructionDetails/TFPAAdditionalDetails/TFPAAdditionalDetails';
import Heating from '../../components/ConstructionDetails/Heating/HeatingComponent';
import Plumbing from '../../components/ConstructionDetails/Plumbing/PlumbingComponent.jsx';
import Electrical from '../../components/ConstructionDetails/Electrical/ElectricalComponent.jsx';
import TWIACleanseObjUtil from '../../../twia-capability-quoteandbind-TWIAResidential-react/util/TWIACleanseObjUtil';
import metadata from './ConstructionPage.metadata.json5';
import styles from './ConstructionPage.module.scss';
import wizardStyles from '../../../../modules-react/tfpa-portals-wizard-components-ui/templates/TFPAWizardTemplate.module.scss';
import messages from './ConstructionPage.messages.js';
import { useTranslator } from '@jutro/locale';
import { Icon, InlineNotification } from '@jutro/components';
import { flow } from 'lodash/fp.js';
import ErrorPopupUtil from 'ent-components-platform-react/util/ErrorPopupUtil.js';
import { wizardMessages } from 'tfpa-portals-wizard-components-ui';

function TFPAConstructionPage(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { wizardData: submissionVM, updateWizardData, steps } = props;
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const viewModelService = useContext(ViewModelServiceContext);
    const { authHeader } = useAuthentication();
    const [showErrors, setShowErrors] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorDescription, setShowErrorDescription] = useState();
    const [errorSets, setErrorSets] = useState([]);
    const [invalidComponent, setInvalidComponents] = useState([]);
    const translator = useTranslator();
    const { showAlert } = useModal();

    const {
        isComponentValid,
        initialValidation,
        onValidate,
    } = useValidation('ConstructionPage');

    const { refreshData } = useDataRefresh();
    const policyType =  _.get(submissionVM.value, 'lobData.homeowners_tfpa.policyType_TWIA');
    const construction = _.get(submissionVM, 'lobData.homeowners_tfpa.coverables.construction');

    if (construction.value === undefined || construction.value === null) {
        construction.value = {};
    }
    // Ensure year purchased field is populated for Construction DTO
    submissionVM.lobData.homeowners_tfpa.coverables.construction.yearPurchased = submissionVM.lobData.homeowners_tfpa.coverables.yourHome.yearPurchased;
    

    _.set(submissionVM,`lobData.homeowners_tfpa.coverables.construction.policyType_Ext.value`, policyType);

    useEffect(() => {
        setErrorSets([]);
        TWIACleanseObjUtil.resetAspectsNotVisibleValues(submissionVM.lobData.homeowners_tfpa.coverables.construction);
        if (submissionVM.value.errorsAndWarnings && submissionVM.value.errorsAndWarnings.validationIssues) {
            const errorMessagesSet = getValidationIssues(submissionVM.value.errorsAndWarnings.validationIssues);
            if (errorMessagesSet.length > 0) {
                setShowErrors(true);
                setErrorSets(_.uniq(errorMessagesSet));
            }
        }
    }, []);

    //DTO/PC validation errors
    const getFlowErrors = useCallback ((validationIssues) => {
        // if (validationIssues && ((validationIssues.fieldIssues && validationIssues.fieldIssues.length > 0 )|| (validationIssues.issues && validationIssues.issues.length > 0))) {
         let flowErrors = [];
         if (!_.isUndefined(validationIssues.fieldIssues) && validationIssues.fieldIssues.length > 0) {
             flowErrors = validationIssues.fieldIssues.filter((item) => {
                 return item.flowStepId === "HomeownersDwellingConstruction";
             }).map((item, index) => {
                 return item.reason;
             });
         }
 
         return flowErrors;
         
     }, []);
     
     //PC business errors eg: rating etc..
     const getValidationIssues = useCallback ((validationIssues) => {
        let errorReasons = [];
        let validationFlowReasons = [];
        if (!_.isUndefined(validationIssues.issues) && validationIssues.issues.length > 0) {
            validationFlowReasons = validationIssues.issues.filter((item) => {
                return item.flowStepId === "HomeownersDwellingConstruction";
            }).map((item, index) => {
                return item.reason;
            });

            errorReasons = validationIssues.issues.filter((item) => {
                return _.isUndefined(item.flowStepId);
            }).map((item, index) => {
                return item.reason;
            });
            
        }
 
        return [...errorReasons, ...validationFlowReasons];
      }, []);

    //Combination of all types of errors in quote wizard
    const getErrorMessages = useCallback ((validationIssues) => {
        setErrorSets([]);
        if (validationIssues && ((validationIssues.fieldIssues && validationIssues.fieldIssues.length > 0 )|| (validationIssues.issues && validationIssues.issues.length > 0))) {
            let flowErrors = [];
            if (validationIssues.fieldIssues && validationIssues.fieldIssues.length > 0 ) {
                flowErrors = validationIssues.fieldIssues.filter((item) => {
                    return item.flowStepId === "HomeownersDwellingConstruction";
                }).map((item, index) => {
                    return item.reason;
                });
            }
            let errorReasons = [];
            let validationFlowReasons = [];
            if (validationIssues.issues && validationIssues.issues.length > 0) {
                validationFlowReasons = validationIssues.issues.filter((item) => {
                    return item.flowStepId === "HomeownersDwellingConstruction";
                }).map((item, index) => {
                    return item.reason;
                });

                errorReasons = validationIssues.issues.filter((item) => {
                    return _.isUndefined(item.flowStepId);
                }).map((item, index) => {
                    return item.reason;
                });
                
            }
            refreshData();
            let messages = [...flowErrors, ...validationFlowReasons, ...errorReasons];

            if(messages.length > 0) {
                setShowErrorMessage(true);
                setErrorSets(_.uniq(messages));
                return true;
            } else {
                setShowErrorMessage(false);
                setErrorSets([]);
                return false;
            }
        } else {
            setShowErrorMessage(false);
            setErrorSets([]);
            refreshData();
            return false;
        }
        
    }, [setShowErrorDescription, setShowErrorMessage, setErrorSets, errorSets, refreshData]);

    const checkForIssues = useCallback(() => {
        const { validationIssues } = submissionVM.value.errorsAndWarnings;
        if (validationIssues && validationIssues.issues && validationIssues.issues.length > 0) {
            if (validationIssues.issues[0].flowStepId === "HomeownersDwellingConstruction") {
                setShowErrorMessage(true);
                setShowErrorDescription(validationIssues.issues[0].reason);
                return false;
            }
        }
        return true;
    }, [submissionVM]);

    const parseErrorMessage = errMsg =>  _.split(errMsg, '/')[1];


    const handleError = useCallback(
        // eslint-disable-next-line consistent-return
        (title, messageType, message) => {
            if(messageType === 'warning'){
                return showAlert({
                    title: title,
                    message: message,
                    status: messageType,
                    icon: 'mi-error-outline',
                    confirmButtonText: messages.cancel
                }).catch(_.noop);
            }
            ErrorPopupUtil.showSaveErrorPopup(showAlert, false);     
            return false;     
        }
    );
   
    const saveData = useCallback(async () => {
        try {
            const newSubmissionVM = viewModelService.clone(submissionVM);
            _.set(newSubmissionVM, 'lobData.homeowners_tfpa.offerings', undefined);
            _.set(newSubmissionVM, 'lobData.homeowners_tfpa.coverables.yourHome.primaryAddress.mustStandardize_Ext', false);
            submissionVM.value = await LoadSaveService.updateDraftSubmission(
                newSubmissionVM.value,
                authHeader
            )
            updateWizardData(submissionVM);
            return submissionVM;
        } catch (e){
            // Handle errors
            const messageType = e?.appErrorCode === 10000 ? 'warning' : 'error';
            const errMsg =  parseErrorMessage(e.baseError);
            handleError(messages.titleDwellingValidationError, messageType, errMsg);
        }
    }, [viewModelService, submissionVM, LoadSaveService, authHeader,
        updateWizardData, handleError]);

    const onNext = useCallback(async () => {
        if (invalidComponent.length > 0) {
            setShowErrors(true)
            return false;
        }
        setShowErrors(false);
        return saveData().then(result => {
            const errorsAndWarnings = _.get(result, 'value.errorsAndWarnings.validationIssues');
            const errorMessages = getErrorMessages(errorsAndWarnings) !== false;
            setShowErrors(errorMessages);
            return !result || errorMessages ? false : submissionVM;
        });
    }, [invalidComponent, saveData, getErrorMessages, submissionVM]);

    const onPrevious = useCallback(async () => {
        if (invalidComponent.length > 0 && !construction.aspects.subtreeValid) {
            showAlert({
                title: wizardMessages.TWIAWizardModalTitle,
                message: wizardMessages.TWIAWizardModalMessage,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: wizardMessages.TWIAWizardModalConfirm,
                cancelButtonText: wizardMessages.TWIAWizardModalCancel,
            }).catch(_.noop);
        } else {
            saveData().then(result => {
                const errorsAndWarnings = _.get(result, 'value.errorsAndWarnings.validationIssues');
                const errorMessages = getErrorMessages(errorsAndWarnings) !== false;
                setShowErrors(errorMessages);
                return !result || errorMessages ? false : submissionVM;
            });
        }        
    }, [invalidComponent, saveData, getErrorMessages, submissionVM]);

    const findInvalidComponent = useCallback((isValid, componentID) => {
        if (isValid === false) {
            setInvalidComponents((oldValue) => [...oldValue, componentID]);
        }

        if (isValid === true) {
            setInvalidComponents((oldValue) => oldValue.filter((val) => val !== componentID));
        }
    }, []);

    const errorContent = useCallback(
        item => {
            return (
                <InlineNotification id={item} 
                message={item}
                type= "error"
                className= {wizardStyles.marginBottom}
                isDismissable= {false}
                />
            );
        },
        []
    );

    const generateOverrides = useMemo(() => {
        const overrides = errorSets.map((item, index) => {
            return {
                [`errorMsg${index}`]: {
                    content: errorContent(item),
                },
            };
        });
        return Object.assign({}, ...overrides);
    }, [errorSets, errorContent]);
    
    // DE15501
    const currentLocationCounty = _.get(submissionVM, 'lobData.homeowners_tfpa.coverables.yourHome.primaryAddress_TWIA.county.value');
    
    function harrisCountyMessage() {
        return (
            <div>
                <span style={{ display: 'flex' }}>
                    <Icon id="icon" icon="gw-info" title="Info" color="#4074ce" />
                    <h5 style={{ paddingLeft: '4px'}}>{'Info: '}</h5>
                    <text style={{ paddingLeft: '6px'}}>{translator(messages.messageLine0)}</text>
                </span>
                <ol style={{ marginBottom: '0rem', marginLeft: '2.2rem'}} start="1">
                    <li>{translator(messages.messageLine1)}</li>
                    <li>{translator(messages.messageLine2)}</li>
                    <li>{translator(messages.messageLine3)}</li>
                </ol>
            </div>
        );
    };


    const overrideProps = {
        '@field': {
            // apply to all fields
            showOptional: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        constructionDetails: {
            submissionVM, updateWizardData, showErrors, findInvalidComponent, steps, onValidate
        },
        addlConstruction: {
            submissionVM, updateWizardData, showErrors, findInvalidComponent, onValidate
        },
        roofUpdates: {
            submissionVM, updateWizardData, showErrors, findInvalidComponent, onValidate
        },
        repairsOrAdds: {
            submissionVM, updateWizardData, showErrors, findInvalidComponent, onValidate
        },
        heating: {
            submissionVM, updateWizardData, showErrors, findInvalidComponent, onValidate
        },
        plumbing: {
            submissionVM, updateWizardData, showErrors, findInvalidComponent, onValidate
        },
        electrical: {
            submissionVM, updateWizardData, showErrors, findInvalidComponent, onValidate
        },
        constructionDetailsAccordion: {
            errorState: _.includes(invalidComponent, 'TFPAConstructionDetails') && showErrors
        },
        roofUpdatesAccordion: {
            visible: policyType === 'HO3' || policyType === 'DP2',
            errorState: _.includes(invalidComponent, 'ENTRoofUpdatesComponent') && showErrors,

            title: _.get(submissionVM.value, 'lobData.homeowners_tfpa.policyType_TWIA') === 'TWRM' ? translator(messages.mhTitleRoofDetails) : translator(messages.titleRoofDetails) // DE15494
        },
        heatingAccordion: {
            submissionVM,
            visible: policyType === 'HO3' || policyType === 'DP2' || policyType === 'HO6',
            errorState: _.includes(invalidComponent, 'Heating') && showErrors,
            title: translator(messages.titleHeating) 
        },
         plumbingAccordion: {
            visible: policyType === 'HO3' || policyType === 'DP2',
            errorState: _.includes(invalidComponent, 'Plumbing') && showErrors,
            title: translator(messages.titlePlumbing)
        },
        electricalAccordion: {
            visible: policyType === 'HO3' || policyType === 'DP2',
            errorState: _.includes(invalidComponent, 'Electrical') && showErrors,
            title: translator(messages.titleElectrical)
        },
        additionalConstructionAccordion: {
            errorState: _.includes(invalidComponent, 'TFPAAdditionalDetails') && showErrors,
            visible: _.get(submissionVM.value, 'lobData.homeowners_tfpa.policyType_TWIA') !== 'TWRM' // DE15494
        },
        additionalConstructionAccordionMH: {
            visible: _.get(submissionVM.value, 'lobData.homeowners_tfpa.policyType_TWIA') === 'TWRM' ? true : false,
        },
        infoMessage: {
            visible: showErrorMessage,
            message: errorDescription
        },
        accordionBreak: {
            visible: showErrorMessage
        },
        inforMessageL: {
            data: errorSets
        },
        harrisCountyMessage: { // DE15501
            visible: currentLocationCounty === 'Harris',
            content: harrisCountyMessage()
        },
        ...generateOverrides,
        
    };

    const resolvers = {
        resolveComponentMap: {
            questionset: QuestionSetComponent,
            constructionDetailsComponent: TFPAConstructionDetails,
            roofUpdatesComponent: TFPARoofUpdatesComponent,
            addlConstructionComponent: TFPAAdditionalDetails,
            heating: Heating,
            plumbingComponent: Plumbing,
            electricalComponent: Electrical
        },
        resolveClassNameMap: styles,
    };

    return (
        <WizardPage
            onNext={onNext}
            skipWhen={initialValidation}
            //disableNext={!isComponentValid}
            onPrevious={onPrevious}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                showErrors={showErrors}
                onModelChange={updateWizardData}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

TFPAConstructionPage.propTypes = wizardProps;
export default TFPAConstructionPage;
